import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import constants from 'constants';
import LandingView from 'components/Landing/Landing';

const {
  loadUpcomingWebinarsSaga,
  loadCurrentWebinarsSaga,
  loadPreviousWebinarsSaga,
  loadSubscriptionsSaga,
  cleanWebinars
} = actions;

const {
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS } = constants;

class Landing extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: {
        upcoming: 1,
        current: 1,
        previous: 1,
      }
    }
  }

  componentWillMount() {
    this.props.loadUpcomingWebinars(this.state.page.upcoming);
  }

  nextPage = (webinarType) => {
    switch (webinarType) {
      case UPCOMING_WEBINARS:
        this.setState({ page: { ...this.state.page, upcoming: this.state.page.upcoming + 1 } },
          () => this.props.loadUpcomingWebinars(this.state.page.upcoming))
        break;
    }
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  render() {
    return (
      <LandingView
        webinars={this.props.upcoming.values}
        nextPage={() => (this.nextPage(UPCOMING_WEBINARS))}
        page={this.state.page.upcoming}
        count={this.props.upcoming.count}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  upcoming: state.webinars[UPCOMING_WEBINARS],
  current: state.webinars[CURRENT_WEBINARS],
  previous: state.webinars[PREVIOUS_WEBINARS]
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentWebinars: (page) => dispatch(loadCurrentWebinarsSaga(page)),
  loadUpcomingWebinars: (page) => dispatch(loadUpcomingWebinarsSaga(page)),
  loadPreviousWebinars: (page) => dispatch(loadPreviousWebinarsSaga(page)),
  loadSubscriptions: () => dispatch(loadSubscriptionsSaga()),
  cleanWebinars: () => dispatch(cleanWebinars())
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



/** WEBPACK FOOTER **
 ** ./src/containers/Landing/Landing.jsx
 **/